import type { SiteConfig } from "../types";

export const siteConfig: SiteConfig = {
  name: "Shifa Medical Centre",
  tagline: "Healing with Purpose. Changing Lives for Good",
  description:
    "Shifa Medical Centre is a leading multi-specialty hospital in Srinagar, J&K, offering world-class healthcare services across 19 departments with a team of over 50 experienced specialists dedicated to patient-centered care.",
  contact: {
    phone: "0194-247-3648",
    emergency: "0194-247-3383",
    email: "shifamedcenter@gmail.com",
    whatsapp: "9090909090",
  },
  address: {
    street: "Magarmal-Bagh Circle",
    city: "Srinagar",
    state: "J&K",
    pincode: "190008",
    full: "Magarmal-Bagh Circle, Srinagar, J&K 190008",
  },
  hours: [
    { day: "Monday", time: "8:00 AM - 5:00 PM" },
    { day: "Tuesday", time: "8:00 AM - 5:00 PM" },
    { day: "Wednesday", time: "9:00 AM - 6:00 PM" },
    { day: "Thursday", time: "9:00 AM - 6:00 PM" },
    { day: "Friday", time: "10:00 AM - 5:00 PM" },
    { day: "Saturday", time: "10:00 AM - 5:00 PM" },
    { day: "Sunday", time: "Emergency Only" },
  ],
  leadership: {
    director: "Dr. Gulzar Ahmad",
    coChairman: "Dr. Bilal Khan",
  },
  social: {
    facebook: "https://facebook.com/shifamedicalcentre",
    instagram: "https://instagram.com/shifamedicalcentre",
    twitter: "https://twitter.com/shifamedcentre",
    youtube: "https://youtube.com/@shifamedicalcentre",
  },
  stats: {
    years: 25,
    patients: 50000,
    doctors: 50,
    departments: 19,
    satisfaction: 84,
  },
};
